import { saveJsonParse } from './basicFetch'

export const blobFetch = async <TData = any>(
  ...args: Parameters<typeof fetch>
): Promise<TData> => {
  const response = await fetch(...args)

  if (response.ok) {
    return response.blob() as any
  }

  const data = saveJsonParse(await response.text())

  throw {
    response: {
      status: response.status,
      statusText: response.statusText,
      data,
    },
  }
}
